import {createSelector} from '@reduxjs/toolkit'
import {RootState} from '../types'

const selectBasket = (state: RootState) => state.basket

export const selectBasketProducts = createSelector(selectBasket, state => state.basketProducts)
export const selectEditedItem = createSelector(selectBasket, state => state.editedItem)
export const selectOpenHandleEditor = createSelector(selectBasket, state => state.openHandleEditor)
export const selectAddToCartBtnDisable = createSelector(selectBasket, state => state.addToCartBtnDisable)
